import useMapModalStore from '../../../../stores/useMapModalStore';
import useMapViewStore from '../../../../stores/useMapViewStore';

/**
 * Standard close for selection-linked map modals.
 * Mirrors the store/view portion of the former MapCanvas `handleCloseModal`
 * (lighthouse local useState is reset inside LighthouseHost on its own close).
 */
export function closeMapSelectionModal(): void {
  const modal = useMapModalStore.getState();
  modal.closeModal();
  modal.setRealEstateCatalogPlotId(null);
  modal.setPlotFreeOnboarding(false);
  modal.setSalePreviewListing(null);
  modal.setElectionCityHallScreen(null);
  useMapViewStore.getState().setSelectedMapObject(null);
}
